import { r as registerInstance, h } from './index-c269755a.js';

const teliaFooterLegalCss = ".telia-footer-legal{color:#ffffff;display:flex;flex-direction:column}@media screen and (min-width: 64em){.telia-footer-legal{align-items:center;flex-direction:row;justify-content:space-between}}.telia-footer-legal p,.telia-footer-legal telia-list{padding:calc(2.4rem * var(--voca-rem-multiplier)) 0}@media screen and (min-width: 64em){.telia-footer-legal p,.telia-footer-legal telia-list{padding:calc(1.2rem * var(--voca-rem-multiplier)) 0}}.telia-footer-legal p{color:#ffffff;line-height:2;margin:0;opacity:0.6;order:2}@media screen and (min-width: 64em){.telia-footer-legal p{margin:1em 0;order:1}}.telia-footer-legal__list-item{padding:calc(1.2rem * var(--voca-rem-multiplier)) 0;width:100%}@media screen and (min-width: 64em){.telia-footer-legal__list-item{margin-right:calc(3.2rem * var(--voca-rem-multiplier));padding:0;width:auto}}.telia-footer-legal__list-item:last-of-type{margin-bottom:calc(2.4rem * var(--voca-rem-multiplier));margin-right:0}@media screen and (min-width: 64em){.telia-footer-legal__list-item:last-of-type{margin-bottom:0}}.telia-footer-legal__list-item telia-link{font-weight:bold}.telia-footer-legal telia-list{order:1}@media screen and (min-width: 64em){.telia-footer-legal telia-list{order:2}}";

const TeliaFooterLegal = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    /** Tracking id is used to identify and count Component usage */
    this.dataTrackingId = 'telia-footer-legal';
  }
  getItems() {
    if (!this.items) {
      return;
    }
    let localItems;
    if (typeof this.items === 'object') {
      localItems = this.items;
    }
    else {
      localItems = JSON.parse(this.items);
    }
    return localItems.map(item => {
      return (h("li", { class: "telia-footer-legal__list-item" }, h("telia-link", { href: item.href, "dark-background": true, "disable-visited": true, silent: true }, item.name)));
    });
  }
  render() {
    return (h("div", { class: "telia-footer-legal", "data-testid": this.dataTestid }, this.copyright ? h("p", null, this.copyright) : undefined, h("telia-list", { "list-tag": "ul", variant: "row" }, this.getItems()), h("telia-vst", { dataTrackingId: this.dataTrackingId })));
  }
};
TeliaFooterLegal.style = teliaFooterLegalCss;

export { TeliaFooterLegal as telia_footer_legal };
